import type { Release } from '../releases.ts';

export default {
  version: '0.94.0',
  date: '2026-10-09',
  title: 'OGraf conformance kit, a clean last frame, video in graphics',
  summary: [
    'PRISM checks its graphics rendering against the PRISM Graphics conformance kit',
    'OGraf graphics can contain video, kept in step with the picture',
    'A graphic uploaded as a file can be edited in PRISM Graphics',
    'Fixed: the out animation ends on the last frame, so that frame is clean',
    'Fixed: a graphic that cannot draw a moment fails with its own message',
  ],
  features: [
    'OGraf graphics: PRISM now checks itself against the PRISM Graphics conformance kit in its own tests: every case is built as the kit says, and the frames of the sequence viewer and of the export renderer are compared with the kit’s reference frames (picture over grey and over black, transparency, clean edges)',
    'OGraf graphics can contain video (for example a WebM with transparency inside the package). The viewer and exports wait for each video frame before they show or record the picture, so the graphic’s video stays on the picture’s frame',
    'Graphics area: a graphic made in PRISM Graphics can be edited there even when it was uploaded as a file rather than saved from the editor (its package names its editor scene)',
    'Exports: the graphics renderer draws with the same browser settings as the conformance kit’s reference frames',
  ],
  fixes: [
    'OGraf graphics: the out animation now finishes on the clip’s last frame, so that frame is clean (fully transparent) instead of showing a faint trace of the graphic. Stings and the default clip length are unchanged',
    'OGraf graphics: when a graphic reports that it cannot draw a moment, the export and the poster fail with the graphic’s own message instead of recording that frame, and the sequence viewer shows an error on that graphic instead of a picture',
  ],
} satisfies Release;
